import { getElementHeight } from './dom';

export const balanceRowHeight = (rowsToBalance, dataAttribute) => {
    const uniqueKeys = [];

    Array.prototype.forEach.call(rowsToBalance, (row) => {
        const key = row.dataset[dataAttribute];

        if (uniqueKeys.indexOf(key) === -1) {
            uniqueKeys.push(key);
        }
    });
    // iterate through unique keys and find the highest
    uniqueKeys.forEach((key) => {
        const rows = document.querySelectorAll(`[data-${dataAttribute}=${key}]`);
        // find the max height for all multirows
        let maxHeight = 0;
        Array.prototype.forEach.call(rows, (row) => {
            // eslint-disable-next-line no-param-reassign
            row.style.height = 'auto';
            const rowHeight = getElementHeight(row);
            maxHeight = rowHeight > maxHeight ? rowHeight : maxHeight;
        });
        // one last loop through to apply the max height
        Array.prototype.forEach.call(rows, (row) => {
            // eslint-disable-next-line no-param-reassign
            row.style.height = `${maxHeight}px`;
        });
    });
};

/**
 * Balance the heights of cells that have been specified as multiRow
 * @param {String} dataId - the string data id attribute to select for height balancing
 * @param {String} [rowId] - optional rowId to only balance the row with this ID
 */
export const heightFix = (dataId, rowId) => {
    // Need to use requestAnimationFrame to ensure the dom has been
    // painted and we can manipulate dom elements safely
    window.requestAnimationFrame(() => {
        // go through and balance heights after the component has rendered all columns
        if (typeof document !== 'undefined') {
            // build a dom selector based on the data id and optional row id
            const selector = rowId
                ? `[data-${dataId}="${rowId}"]`
                : `[data-${dataId}]`;
            // array with all dom elements that need to be balanced
            const rowsToBalance = document.querySelectorAll(selector);
            // build an array with unique multiRow data ids
            balanceRowHeight(rowsToBalance, dataId);
        }
    });
};
